<template>
	<div class="latform-hypertalk-container">
		<div class="filterBox">
			<div class="searchBox">
				<input type="text" v-model="title" placeholder="请输入您喜欢的超话主题…" />
				<div class="search" @click="communityList">搜索</div>
			</div>
			<div class="filterTitle">超话筛选</div>
			<div class="filterItem">
				<div class="filterItemTitle">超话标签：</div>
				<div class="filterItemList">
					<div class="tip" :class="type == '' ? 'active' : ''" @click="changeType({id: ''})">全部</div>
					<div class="tip" :class="type == item.id ? 'active' : ''" v-for="(item,index) in typeData"
						:key="index" @click="changeType(item)">
						{{item.title}}
					</div>
				</div>
			</div>
			<div class="filterItem">
				<div class="filterItemTitle">排序筛选：</div>
				<div class="filterItemList">
					<div class="tip" :class="active == item.value ? 'active' : ''" v-for="(item,index) in filterData"
						:key="index" @click="changeFilter(item)">{{item.title}}</div>
				</div>
			</div>
		</div>
		<div class="rankListBox">
			<div class="rankList">
				<div class="rankItem" v-for="(item,index) in data" :key="index">
					<div class="work">
						<img class="workImg" :src="item.img" />
						<div class="workInfo">
							<div class="workTitle ellipsis-1">
								{{item.title}}
							</div>
							<div class="workDesc ellipsis-2">
								{{item.content}}
							</div>
							<div class="peopleComment">
								<div class="people">
									<img class="peopleIcon" src="../assets/Home/people.png" />
									{{item.user_num}}人
								</div>
								<div class="comment">
									<img class="commentIcon" src="../assets/Home/comment.png" />
									{{item.dt_num}}个
								</div>
							</div>
							<div class="tips">
								<div class="tip" v-for="(row,rowIndex) in item.label" :key="rowIndex">
									#{{row}}
								</div>
							</div>
						</div>
					</div>
					<div class="goTo" @click="naviToSuperTalkDetails(item)">进入超话</div>
				</div>
			</div>
		</div>
		<PagePagination style="padding: .32rem 0 .6rem;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
	</div>
</template>

<script>
	import PagePagination from '../components/PagePagination.vue'
	export default {
		name: 'SuperTalkCommunity',
		components: {
			PagePagination,
		},
		data() {
			return {
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				data: [],
				type: '',
				title: '',
				active: '',
				typeData: [],
				//关注数优先px_gz活跃度优先px_dt综合排序px_time
				filterData: [{
					title: '默认',
					value: '',
				}, {
					title: '关注数优先',
					value: 'px_gz',
				}, {
					title: '活跃度优先',
					value: 'px_dt',
				}]
			}
		},
		mounted() {
			this.communityType()
			this.communityList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.communityList()
			},
			communityType() {
				this.$api.post('/Community/community_type', {}).then(res => {
					if (res.code == 1) {
						this.typeData = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			communityList() {
				let params = {
					p: this.currentPage,
					title: this.title,
					label: this.type
				}
				if (this.active) {
					params[this.active] = 1
				}
				this.$api.post('/Community/community_list', params).then(res => {
					if (res.code == 1) {
						this.data = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeFilter(item) {
				this.active = item.value
				this.communityList()
			},
			//超话详情
			naviToSuperTalkDetails(item) {
				if (localStorage.getItem('token')) {
					console.log(item)
					this.$router.push({
						path: '/super-talk-details',
						query: {
							id: item.id,
							quId: item.fenqu && item.fenqu.length > 0 ? item.fenqu[0].id : ''
						}
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			changeType(item) {
				this.type = item.id
				this.communityList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.latform-hypertalk-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.filterBox {
		margin-top: .48rem;
		display: flex;
		flex-direction: column;
		width: 12rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		padding: 0 0 .24rem .32rem;

		.searchBox {
			margin: .24rem auto;
			display: flex;
			align-items: center;
			border-radius: .06rem;
			border: 0.01rem solid #E29358;
			width: 5.9rem;
			height: .4rem;

			input {
				width: 4.9rem;
				height: .38rem;
				margin-left: .12rem;
				padding: 0 0;
				border: none;
				font-weight: 400;
				font-size: .14rem;
			}

			.search {
				width: .88rem;
				height: .4rem;
				background: #E29358;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: 0 .06rem .06rem 0;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				line-height: .4rem;
				text-align: center;
				cursor: pointer;
			}
		}

		.filterTitle {
			font-weight: 500;
			font-size: .14rem;
			color: #000000;
		}

		.filterItem {
			display: flex;
			font-size: .14rem;

			.filterItemTitle {
				margin-top: .16rem;
				height: .28rem;
				line-height: .28rem;
				width: .75rem;
				font-weight: 400;
				color: #000000;
			}

			.filterItemList {
				width: calc(100% - .75rem);
				display: flex;
				flex-wrap: wrap;

				.tip {
					margin-top: .16rem;
					margin-right: .24rem;
					height: .28rem;
					line-height: .28rem;
					font-weight: 400;
					color: #666666;
					cursor: pointer;

					&.active {
						color: #000000;
						padding: 0 .1rem;
						background: #E29358;
						box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
						border-radius: .06rem;
					}
				}
			}
		}
	}

	.rankListBox {
		width: 12rem;
		margin-top: .16rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		overflow: hidden;

		.rankList {
			display: flex;
			flex-direction: column;
			padding: 0 .48rem 0 .32rem;

			.rankItem:last-child {
				border-bottom: none;
			}

			.rankItem {
				height: 2.24rem;
				display: flex;
				align-items: center;
				border-bottom: .01rem solid #EAEAEA;
				position: relative;

				.work {
					margin-left: .16rem;
					display: flex;

					.workImg {
						width: 1.6rem;
						height: 1.6rem;
						border-radius: .08rem;
						object-fit: cover;
					}

					.workInfo {
						width: 5.1rem;
						margin-left: .24rem;
						display: flex;
						flex-direction: column;

						.workTitle {
							font-weight: 600;
							font-size: .24rem;
							color: #000000;
						}

						.workDesc {
							margin-top: .1rem;
							font-weight: 400;
							font-size: .14rem;
							line-height: .2rem;
							color: #333333;
						}

						.peopleComment {
							margin-top: .16rem;
							display: flex;
							align-items: center;

							.people,
							.comment {
								margin-right: .2rem;
								display: flex;
								align-items: center;
								font-weight: 400;
								font-size: .14rem;
								color: #7C400E;
								line-height: .2rem;
							}

							.peopleIcon,
							.commentIcon {
								width: .14rem;
								height: .14rem;
								margin-right: .08rem;
							}
						}

						.tips {
							margin-top: .1rem;
							display: flex;
							align-items: center;

							.tip {
								font-size: .14rem;
								color: #786F22;
								line-height: .2rem;
								margin-right: .166rem;
							}
						}
					}
				}

				.goTo {
					position: absolute;
					top: calc(50% - .2rem);
					right: 0;
					width: 1.52rem;
					height: .4rem;
					box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
					border-radius: .06rem;
					border: .01rem solid #E29358;
					font-weight: 400;
					font-size: .14rem;
					color: #E29358;
					text-align: center;
					line-height: .4rem;
					text-decoration: none;
					cursor: pointer;
				}
			}
		}
	}
</style>